import React, {useCallback, useContext, useEffect, useState} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';
import MATrim4TN from './mA-trim4TN';

function MATrim4({onExit, initiallyDisableKeypress}) {
  const [isKeypressDisabled, setIsKeypressDisabled] = useState(initiallyDisableKeypress);
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onRight = useCallback(() => {
    onExit();
    onComponent(<MATrim4TN />);
  }, []);

  useEffect(() => {
    if (!leftPress || isKeypressDisabled) return;

    onExit();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress || isKeypressDisabled) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft: onExit, onRight});
  }, [onExit, onRight]);

  useEffect(() => {
    if (!initiallyDisableKeypress) return;

    setTimeout(() => {
      setIsKeypressDisabled(false);
    }, 500);
  }, []);

  return (
    <BodyContentView
      title="4.0 mA Trim"
      left="Back"
      right="Continue"
      caption="The mA output will be set to 4.0 mA. Enter the observed output on the following screen."
    />
  );
}

export default MATrim4;
